import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

const zoomLevels = [0.25, 0.5, 0.75, 1];

function ExamImageZoom(props) {
	const { zoomLevel } = props;

	return (
		<div style={{ minWidth: '300px' }}>
			<FormControl variant="outlined" className="w-full">
				<InputLabel id="zoom-label">Nagyítás mértéke</InputLabel>
				<Select labelId="zoom-label" id="zoom" label="Nagyítás mértéke" value={zoomLevel} defaultValue={null} onChange={e => props.onChange(e.target.value)}>
					{zoomLevels.map(zoom => (
						<MenuItem key={zoom} value={zoom}>
							{zoom * 100} %
						</MenuItem>
					))}

					<MenuItem value={0}>Képernyőhöz igazít</MenuItem>
				</Select>
			</FormControl>
		</div>
	);
}

export default ExamImageZoom;
